import React from "react"

import UserIcon from "../../../gd-ui/icon/user/user"
import {
    PortfolioAccessDescriptionDictionary,
    PortfolioAccessLabelDictionary,
    PortfolioUserAccess
} from "../../../gd/const/portfolio"
import FieldsFactory from "../../../fields3/fields-factory"
import {FieldType} from "../../../fields3/field-type"
import FieldInlineEditable from "../../../fields3/render/inline-editable"

type Props = {
    selected    : any[]

    onRoleSelect: {(userId:ID, access:PortfolioUserAccess):void}
    onUserClick : {(userId:ID, type:string, e:any):void}
}

export default function ModalAddUserCompanyUsersPortfolio(props:Props) {

    const onRoleSelect = (userId:ID, access:PortfolioUserAccess) => {props.onRoleSelect(userId, access)}
    const onUserClick = (userId:ID, e:any) => {props.onUserClick(userId, 'company', e)}

    const companyUsers = _.get(props,'companyUsers', [])

    const selectedArr = props.selected.map(obj=>obj.userId)

    const customAccessOptions = [
        {
            value           : PortfolioUserAccess.FULL,
            label           : PortfolioAccessLabelDictionary[PortfolioUserAccess.FULL],
            description     : PortfolioAccessDescriptionDictionary[PortfolioUserAccess.FULL],
        },
        {
            value           : PortfolioUserAccess.STANDARD,
            label           : PortfolioAccessLabelDictionary[PortfolioUserAccess.STANDARD],
            description     : PortfolioAccessDescriptionDictionary[PortfolioUserAccess.STANDARD],
        },
    ]

    const field = FieldsFactory.get({
        fieldId : 'access',
        type    : FieldType.PROJECT_ACCESS,
        options : customAccessOptions
    })

    return (
        <div className="ui5-manage-list users-with-access multiselect">
            {_.map(companyUsers,(cu:any, key)=>{
                const isSelected = selectedArr.includes(cu.user.id);

                const classes = Classes('row', {
                    selected: isSelected
                });

                const checkboxClasses = Classes('ui5-cb', 's-16', {
                    selected: isSelected
                });

                const selectedItem = _.find(props.selected, (o)=>o.userId === cu.user.id);

                return (
                    <div className={classes} key={key} onClick={(e)=>{onUserClick(cu.user.id, e)}}>
                        <div className="cell center">
                            <div className={checkboxClasses}/>
                        </div>

                        <div className="cell content">
                            <UserIcon userId={cu.user.id} size="26" className="m-r-10" />
                            <div className="user-name">{cu.user.name}</div>
                        </div>
                        <div className="cell">
                            {isSelected &&
                                <div className="access-block">
                                    <div className="lbl">access:</div>
                                    <FieldInlineEditable className   = "select-access"
                                                         field       = {field}
                                                         model       = {{
                                                             access: selectedItem.access,
                                                         }}
                                                         onChange    = {(access:any)=>{onRoleSelect(cu.user.id, access)}} />
                               </div>}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}